export const formatNumber = (num: number | any): string => {
  if (num < 10000) return num.toString();
  if (num < 1000000) return (num / 1000).toFixed(1).replace(".0", "") + "K";
  if (num < 1000000000)
    return (num / 1000000).toFixed(1).replace(".0", "") + "M";
  return (num / 1000000000).toFixed(1).replace(".0", "") + "B";
};

export const formatDuration = (seconds: number | any): string => {
  if (seconds === null || seconds === undefined || isNaN(seconds))
    return "0h 0m";

  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);

  if (hrs > 0 && mins > 0) return `${hrs}h ${mins}m`;
  if (hrs > 0) return `${hrs}h`;
  return `${mins}m`;
};

export const formatAvgDuration = (seconds: number | any): string => {
  if (seconds === null || seconds === undefined || isNaN(seconds)) return "0s";

  const hrs = Math.trunc(seconds / 3600);
  const mins = Math.trunc((seconds % 3600) / 60);
  const secs = Math.round(seconds % 60);

  if (hrs > 0 && mins > 0) return `${hrs}h ${mins}m`;
  if (hrs > 0) return `${hrs}h ${mins}m`;
  if (mins > 0) return `${mins}m ${secs}s`;
  return `${secs}s`;
};

export const formatPercentage = (num: number | any): string => {
  if (num === null || num === undefined || isNaN(num)) return "0%";
  return `${parseFloat(num).toFixed(2)}%`;
};

export const formatTime = (time: string | number | any): string => {
  if (time === null || time === undefined || time === "") return "--:--";

  let hours: number;
  let minutes: number;

  if (typeof time === "number") {
    hours = Math.floor(time);
    minutes = Math.round((time - hours) * 60);
  } else if (typeof time === "string" && time.includes(":")) {
    const [h, m] = time.split(":").map((v) => parseInt(v, 10));
    hours = h;
    minutes = m;
  } else {
    return "--:--";
  }

  if ((hours === 0 || hours === 24) && minutes === 0) {
    return "--:--";
  }

  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
